const stats = [
  { num: "1.7 亿", label: "科技论文，覆盖全球核心期刊" },
  { num: "1 亿", label: "发明专利，支撑创新研究" },
  { num: "1800 万", label: "全球科研项目（40+ 国家）" },
  { num: "15 万", label: "企业指标，追踪产业动态" },
];

export default function StatsSection() {
  return (
    <section className="bg-[#0f0f0f] border-y border-white/5 py-10">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-white mb-1">{s.num}</div>
              <div className="text-xs text-white/40 leading-relaxed">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
